import { useEnum } from "@/api/services/global/enum";
import { IconErrorOutline } from "@/assets/icons";
import { InnerBox } from "@/components/elements/InnerBox";
import { DATE_FORMAT } from "@/constants/datetime";
import { MatchInfoItem } from "@/features/match/components/match-info/MatchInfoItem";
import { TMatchInfo } from "@/features/match/types/MatchInfo";
import { black } from "@/theme/colors";
import { FCC } from "@/types/common";
import { EMatchContractStatus, LABEL_DATE_CONTRACT_STATUS_MATCH } from "@/types/enum";
import { findLabelByValue } from "@/utils/object";
import { Stack, Grid, Typography, Box } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";

type TMatchContractInfoProps = {
  defaultValues: Partial<TMatchInfo>;
};

export const MatchContractInfo: FCC<TMatchContractInfoProps> = ({ defaultValues }) => {
  const { data: matchContractStatusOptions } = useEnum("EMatchContractStatus");

  const getDateByContractStatus = (contractStatus: string): string | null => {
    const CONTRACT_STATUS_TO_DATE_FIELD: Record<EMatchContractStatus, keyof typeof defaultValues> = {
      [EMatchContractStatus.DURING_CONTRACT]: "contractStartDate",
      [EMatchContractStatus.TRIAL]: "trialStartDate",
      [EMatchContractStatus.CANCELED_CONTRACT]: "contractEndDate",
      [EMatchContractStatus.TRIAL_CANCELLED]: "trialEndDate",
    };

    const dateField = CONTRACT_STATUS_TO_DATE_FIELD[contractStatus as EMatchContractStatus];
    const date = defaultValues?.[dateField] as Dayjs;
    return date ? dayjs(date).format(DATE_FORMAT) : null;
  };

  return (
    <InnerBox showDivider={false} padding={3}>
      <Stack alignItems="flex-start">
        <Typography variant="head20Bold" color={black[30]}>
          契約情報
        </Typography>

        <Grid mt={2} container columnSpacing={3} rowSpacing={1}>
          <Grid item xs={12} sm={6}>
            <MatchInfoItem
              label="契約ステータス"
              value={findLabelByValue(matchContractStatusOptions, defaultValues.contractStatus) ?? defaultValues.contractStatus}
              isShowDivider={false}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MatchInfoItem
              label={
                defaultValues.contractStatus && defaultValues.contractStatus in LABEL_DATE_CONTRACT_STATUS_MATCH
                  ? LABEL_DATE_CONTRACT_STATUS_MATCH[defaultValues.contractStatus as keyof typeof LABEL_DATE_CONTRACT_STATUS_MATCH]
                  : "契約日"
              }
              value={defaultValues.contractStatus && getDateByContractStatus(defaultValues.contractStatus)}
              isShowDivider={false}
            />
          </Grid>

          <Grid item xs={12} mt={2}>
            <Stack>
              <Typography variant="cap12" color={black[70]}>
                <Box component="span" sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <IconErrorOutline fontSize="20px" color={black[80]} />
                  irohana studyの契約に関するご要望は、別途お問い合わせください。
                </Box>
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </InnerBox>
  );
};
